// 底座编号
export const sBaseNo = {
  id: 1,
  text: $t('integration.base_number'),
  type: 'input',
  paramsName: 'code',
  isChooze: true
}

// 监测点
export const sCarrier = {
  id: 2,
  text: 'public.carrier',
  type: 'input',
  paramsName: 'carrierName',
  isChooze: false,
  selectParam: []
}

// 绑定设备
export const sBindedDevice = {
  id: 3,
  text: $t('integration.bind_device'),
  type: 'input',
  paramsName: 'device',
  isChooze: false
}

// 底座类型
export const sBaseType = {
  id: 4,
  text: $t('integration.type'),
  type: 'select',
  paramsName: 'type',
  isChooze: false,
  selectParam: []
}

export const sBaseStatus = {
  id: 5,
  text: $t('integration.status'),
  type: 'select',
  paramsName: 'situation',
  isChooze: false,
  selectParam: [
    {
      value: 0,
      label: $t('integration.fall_off')
    },
    {
      value: 1,
      label: $t('integration.embed')
    }
  ]
}

// 是否已绑定监测点
export const sBindCarrier = {
  id: 6,
  text: $t('integration.binding'),
  type: 'select',
  paramsName: 'bind',
  isChooze: false,
  selectParam: [
    {
      value: 0,
      label: $t('integration.unbound_monitoring_point')
    },
    {
      value: 1,
      label: $t('integration.bound_monitoring_point')
    }
  ]
}
